import { gql } from '@apollo/client';

export const REMOVE_FIND_GROUP_COLLABORATOR_MUTATION = gql`
  mutation RemoveFindGroupCollaboratorMutation(
    $groupId: String!
    $userId: String!
  ) {
    removeFindGroupCollaborator(groupId: $groupId, userId: $userId) {
      ... on RemoveFindGroupCollaboratorSuccess {
        result
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
